import topSellerImg from './top-seller-image.png'

export const topSellers = [
  {
    img: topSellerImg,
    name: 'Nick Jones',
    rating: '4.96',
    star: 5,
  }
]